export const ORDER_TYPE = {
    LEARNER: 'LEARNER',
    THIRD_PARTY: 'THIRD_PARTY'
};
